import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import RetencionesCatalogoManager from '../../../../catalogs/managers/RetencionesCatalogoManager';

const DetallesDelServicioForm = (props) => {
  const [catalogos, setCatalogos] = useState({});
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  useEffect(() => {
    const loadCatalogs = async () => {
      const FormaPagoServ = await RetencionesCatalogoManager.get('r_spt_forma_pago_servicio');
      const TipoDeServ = await RetencionesCatalogoManager.get('r_spt_tipo_servico');
      const SubTipServ = await RetencionesCatalogoManager.get('r_spt_subtipo_servicio');

      const catalogos = {};

      catalogos.FormaPagoServ = await syncCatalog(FormaPagoServ);
      catalogos.TipoDeServ = await syncCatalog(TipoDeServ);
      catalogos.SubTipServ = await syncCatalog(SubTipServ);

      setCatalogos(catalogos);
    };

    loadCatalogs();
  }, []);

  const syncCatalog = async (values) => {
    if (!!values) {
      const sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion,
            value: item.clave,
          };
        }),
        'label'
      );

      return [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(sorted);
    }
  };

  const getRules = (data) => {
    return {
      FormaPagoServ: ['required', 'string'],
      TipoDeServ: ['required', 'string'],
      SubTipServ: ['string', 'string'],
      RFCTerceroAutorizado: [
        'string',
        'min:12',
        'max:13',
        'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/',
      ],
      FechaServ: ['required'],
      PrecioServSinIVA: ['required', 'decimal:6'],
    };
  };

  const handleOnChange = (value) => {
    const data = {
      ...props.data,
      ...value,
    };

    const validator = validate(data);

    props.onFormDataChange(
      {
        ...data,
      },
      {
        name: 'isValidDetallesDelServicio',
        isValid: validator.passes(),
      }
    );
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="Forma pago servicio"
          name="FormaPagoServ"
          placeholder=""
          help=""
          rules={rules.FormaPagoServ}
          value={data.FormaPagoServ}
          options={catalogos.FormaPagoServ}
          onChange={handleOnChange}
        />
      </Col>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="Tipo de Servicio"
          name="TipoDeServ"
          placeholder=""
          help=""
          rules={rules.TipoDeServ}
          value={data.TipoDeServ}
          options={catalogos.TipoDeServ}
          onChange={handleOnChange}
        />
      </Col>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="Subtipo Servicio"
          name="SubTipServ"
          placeholder=""
          help=""
          rules={rules.SubTipServ}
          value={data.SubTipServ}
          options={catalogos.SubTipServ}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="text"
          label="RFC tercero autorizado"
          name="RFCTerceroAutorizado"
          placeholder=""
          help=""
          casing={'upper'}
          minLength={12}
          maxLength={13}
          rules={rules.RFCTerceroAutorizado}
          value={data.RFCTerceroAutorizado}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="date-picker"
          label="Fecha servicio"
          name="FechaServ"
          rules={rules.FechaServ}
          value={data.FechaServ}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Precio servicio sin iva"
          name="PrecioServSinIVA"
          placeholder=""
          help=""
          rules={rules.PrecioServSinIVA}
          value={data.PrecioServSinIVA}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default DetallesDelServicioForm;
